export interface RecordFormData {
  name: string;
  type: string;
  value: string;
  ttl: string;
  // SRV
  priority: string;
  weight: string;
  port: string;
  // CAA
  caa_flags: string;
  caa_tag: string;
  caa_value: string;
  // DS
  ds_key_tag: string;
  ds_algorithm: string;
  ds_digest_type: string;
  ds_digest: string;
  // TLSA
  tlsa_usage: string;
  tlsa_selector: string;
  tlsa_matching_type: string;
  tlsa_data: string;
  // SSHFP
  sshfp_algorithm: string;
  sshfp_type: string;
  sshfp_fingerprint: string;
  // NAPTR
  naptr_order: string;
  naptr_preference: string;
  naptr_flags: string;
  naptr_service: string;
  naptr_regexp: string;
  naptr_replacement: string;
  // Alias (Route53 A/AAAA)
  aliasEnabled: boolean;
  alias_name: string;
  alias_hosted_zone_id: string;
}

export const RECORD_TYPES = [
  'A',
  'AAAA', 
  'CNAME',
  'MX',
  'TXT',
  'NS',
  'SOA',
  'SRV',
  'CAA',
  'PTR',
  'HTTPS',
  'SVCB',
  'LOC',
  'NAPTR',
  'SSHFP',
  'URI',
  'SPF',
  'DS',
  'DNSKEY',
  'TLSA',
];

export const getInitialFormData = (): RecordFormData => ({
  name: '',
  type: 'A',
  value: '',
  ttl: '300',
  priority: '',
  weight: '',
  port: '',
  caa_flags: '',
  caa_tag: 'issue',
  caa_value: '',
  ds_key_tag: '',
  ds_algorithm: '',
  ds_digest_type: '',
  ds_digest: '',
  tlsa_usage: '',
  tlsa_selector: '',
  tlsa_matching_type: '',
  tlsa_data: '',
  sshfp_algorithm: '',
  sshfp_type: '',
  sshfp_fingerprint: '',
  naptr_order: '',
  naptr_preference: '',
  naptr_flags: '',
  naptr_service: '',
  naptr_regexp: '',
  naptr_replacement: '',
  aliasEnabled: false,
  alias_name: '',
  alias_hosted_zone_id: '',
});